module.exports = __webpack_public_path__ + "img/82_11.220d1ca8.png";